/**
 * Pure helpers for CitySearchSelect (schedules single-city picker).
 */

/** @param {Array<{id: number|string, name?: string}>} cities */
export function sortCitiesByName(cities) {
  return [...(cities || [])].sort((a, b) =>
    (a.name || '').localeCompare(b.name || '', 'ru', { sensitivity: 'base' })
  );
}

/** @param {Array<{id: number|string, name?: string}>} cities */
/** @param {number|string|null|undefined} value */
export function resolveSelectedCity(cities, value) {
  if (value == null || value === '') return null;
  return (cities || []).find((c) => Number(c.id) === Number(value)) || null;
}

/** @param {Array<{id: number|string, name?: string}>} cities */
/** @param {string} query */
export function filterCitiesByQuery(cities, query) {
  const list = sortCitiesByName(cities);
  const q = (query || '').trim().toLowerCase();
  if (!q) return list;
  return list.filter((c) => (c.name || '').toLowerCase().includes(q));
}
